export const version = "bignumber/5.3.0";
//# sourceMappingURL=_version.js.map